package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class ReportReason {
    INAPPROPRIATE,
    UNSAFE_CODE,
    COPYRIGHT,
    OTHER
}

@Serializable
data class AssetReportRequest(
    val reason: ReportReason,
    val comment: String? = null
)

@Serializable
data class AssetReportResponse(
    val accepted: Boolean,
    val incidentId: Int? = null
)

@Serializable
data class ModerationIncidentDto(
    val id: Int,
    val createdAtMs: Long,
    val kind: String,
    val surface: String,
    val category: String,
    val rule: String,
    val excerpt: String,
    val sessionHash: String? = null,
    val assetId: String? = null,
    val comment: String? = null,
    val status: String,
    val resolvedAtMs: Long? = null
)
